import { generate } from '@/utils/request';
const config = {
  prefix: '/sfin/v1',
  items: [
    // 查询导入历史
    { key: 'getImportManager', url: '/{organizationId}/import/manager', method: 'GET' },
    // 从文件导入临时表(异步)
    {
      key: 'importDataUpload',
      url: '/{organizationId}/import/data/data-upload',
      method: 'POST',
      type: 'form',
    },
  ],
};
export default {
  ...generate(config),
};
